<template>
    <div class="filter-content-entry" data-tab="services">
        <div class="filter-content-entry-mobile-title">
            <a href="#" class="btn btn-rebrand-grey-outline btn-rebrand-xxs px-2 back">{{translate.account.onboard.back}}</a>
            <span class="filter-title">{{translate.home.services}}</span>
            <a href="#" class="btn btn-rebrand-black btn-rebrand-xxs ml-auto px-2"
               @click.prevent="clearAllFilters()">{{translate.home.clearAll}}</a>
        </div>
        <div class="row mb-5 filter-content-your-selection">
            <div class="col-md-12">
                <div class="section-heading mt-0 pt-0 border-0">{{translate.home.yourSelection}}</div>
                <div class="filter-content-your-selection-list">
                    <search-filter-flairs-scoped-component
                        :filterProp="'services'"
                    ></search-filter-flairs-scoped-component>
                    <a href="#" class="clear-filter-link"
                       @click.prevent="clearAllFilters()">{{translate.home.clearAll}}</a>
                </div>
            </div>
        </div>
        <div class="row filter-content-container">
            <div class="col-md-12">
                <div class="services-grid">
                    <div class="popular-services-list">
                        <div class="section-heading mt-0">{{translate.home.popularServices}}</div>
                        <div class="checkbox-list-v2 checkbox-list-v2--large">
                            <section v-for="(service,key) in filteredPopularServices">
                                <input type="checkbox" name="servicesPopular" :id="'service-popular' + key"
                                       :value="service.id"
                                       :checked="serviceIsChecked(service)"
                                >
                                <label :for="'service-popular-' +key" @click="onPopularServiceClicked(service)">{{ translateService(service.title) }}</label>
                            </section>
                        </div>
                    </div>

                    <div class="services-search">
                        <div class="search-input search-input--redesign">
                            <input :value="searchQuery"
                                   @input="e => searchQuery = e.target.value"
                                   type="text" id="searchServices"/>
<!--                            <label for="searchServices">{{translate.home.searchList}}</label>-->
                        </div>
                    </div>

                    <div class="services-list">
                        <div class="section-heading">{{translate.home.allServices}}</div>

                        <div class="double-column-services">
                            <div class="checkbox-list-v2 checkbox-list-v2--large">
                                <template v-for="(topService,key) in filteredServices">

                                    <section class="topService">
                                        <input type="checkbox" name="services" :id="'service-top-' + key"
                                               :value="topService.id"
                                               :checked="serviceIsChecked(topService)"
                                               @click="onTopServiceClicked(topService)"
                                        >
                                        <label :for="'service-top-' + key">{{ translateService(topService.title) }}</label>
                                    </section>

                                    <section class="subService" v-for="(service,key2) in topService.children">
                                        <input type="checkbox" name="services" :id="'service-' +key +'-' + key2"
                                               :value="service.id"
                                               :checked="serviceIsChecked(service)"
                                               @click="onSubServiceClicked(service)"
                                        >
                                        <label :for="'service-' +key +'-' + key2">{{ translateService(service.title) }}</label>
                                    </section>

                                </template>
                            </div>
                        </div>


                    </div>

                </div>

            </div>
        </div>
    </div>

</template>

<script>
import translateMixin from "@/components/mixins/translateMixin";

const data = () => {
        return {
            store: $store,
            servicesPopular: [
                {id: 19, title: 'Erotische Massage', parent_id: null},
                {id: 40, title: 'Nuru Massage', parent_id: 19},
                {id: 57, title: 'Tantra Massage', parent_id: 19},
                {id: 64, title: 'Domina', parent_id: 23},
                {id: 28, title: 'Gangbang', parent_id: 23},
                {id: 63, title: '69', parent_id: null},
                {id: 58, title: 'Dreier', parent_id: null},
                {id: 49, title: 'Rollenspiele', parent_id: null},
            ],
            selectedPopular: [],
            searchQuery: ''
        }
    };

    function mounted() {
        this.unSubscribe = this.store.subscribe((mutation) => {
            if (mutation.type === 'setFilterOpened'
                && mutation.payload
                && (!Object.keys(this.servicesTemp).length)
            ) {
                this.store.commit('setServicesTemp', _.cloneDeep(this.services));
            }
        });
    }

    function onTopServiceClicked(topService) {
        const servicesTemp = _.cloneDeep(this.servicesTemp) || [];

        if (_.includes(servicesTemp, topService.id)) {
            servicesTemp.splice(servicesTemp.indexOf(topService.id), 1);

        } else {
            _.forEach(_.get(topService, 'children', []), child => {
                if (_.includes(servicesTemp, child.id)) {
                    servicesTemp.splice(servicesTemp.indexOf(child.id), 1);
                }
            });
            servicesTemp.push(topService.id);
        }

        this.store.commit('setServicesTemp', _.uniq(servicesTemp));
    }

    function onSubServiceClicked(subService) {

        const topService =_.filter(this.topServices, {id: subService.parent_id})[0];
        const servicesTemp = _.cloneDeep(this.servicesTemp) || [];

        if (_.includes(servicesTemp, topService.id)) {

            servicesTemp.splice(servicesTemp.indexOf(topService.id), 1);

            _.forEach(_.get(topService, 'children', []), child => {
                if (!_.isEqual(child.id, subService.id)) {
                    servicesTemp.push(child.id);
                }
            })

        } else {
            if (_.includes(servicesTemp, subService.id)) {
                servicesTemp.splice(servicesTemp.indexOf(subService.id), 1);
            } else {
                servicesTemp.push(subService.id);

                let childSelected = 0;
                const children = _.get(topService, 'children', []);

                _.forEach(children, child => {
                    if (_.includes(servicesTemp, child.id)) {
                        childSelected++;
                    }
                });

                if (children.length === childSelected) {
                    _.forEach(children, child => {
                        servicesTemp.splice(servicesTemp.indexOf(child.id), 1);
                    });
                    servicesTemp.push(topService.id);
                }

            }
        }

        this.store.commit('setServicesTemp', _.uniq(servicesTemp));
    }

    function onPopularServiceClicked(service) {
        if (service.parent_id) {
            return this.onSubServiceClicked(service);
        }

        const serviceEnriched = _.filter(this.topServices, {id: service.id})[0];
        return this.onTopServiceClicked(serviceEnriched);
    }

    function clearAllFilters() {
        this.store.commit('setServicesTemp', []);
    }

    function serviceIsChecked(service) {
        if (!this.servicesTemp) {
            return false;
        }
        return _.includes(this.servicesTemp, service.id) || _.includes(this.servicesTemp, service.parent_id || -1);
    }

    export default {
        data,
        mounted,
        computed: {
            ...mapState([
                    'services',
                    'servicesTemp',
                    'topServices',
                    'translate',
                ]
            ),
            filteredServices() {
                if (this.searchQuery) {
                    const cloned = _.cloneDeep(this.topServices);

                    _.map(cloned, (service) => {
                        const childrens = _.get(service, 'children', []);

                        if (childrens.length) {
                            const exists = childrens.filter((sub) => {
                                return this.translateService(sub.title).toLowerCase().search(this.searchQuery.toLowerCase()) !== -1;
                            });

                            if (exists.length) {
                                service.children = exists;
                            } else {
                                service.children = [];
                            }
                        } else {
                            service.children = [];
                        }
                    });

                    return cloned.filter((service) => {
                        return service.children.length || this.translateService(service.title).toLowerCase().search(this.searchQuery.toLowerCase()) !== -1;
                    });
                } else {
                    return this.topServices;
                }
            },
            filteredPopularServices() {
                if (!this.searchQuery) {
                    return this.servicesPopular;
                }

                return this.servicesPopular.filter((sub) => {
                    return this.translateService(sub.title).toLowerCase().search(this.searchQuery.toLowerCase()) !== -1;
                });
            },
        },
        methods: {
            clearAllFilters,
            serviceIsChecked,
            onTopServiceClicked,
            onSubServiceClicked,
            onPopularServiceClicked,
        },
        mixins: [translateMixin],
        beforeDestroy() {
            if (this.unSubscribe) {
                this.unSubscribe();
            }
        },
    };
</script>
